import { config, library } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import {
  faAddressBook,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAt,
  faBabyCarriage,
  faBan,
  faCalendar,
  faCalendarCheck,
  faCheck,
  faCog,
  faComment,
  faComments,
  faCreditCard,
  faDog,
  faEllipsisH,
  faEllipsisV,
  faEye,
  faEyeSlash,
  faGift,
  faGlobe,
  faGraduationCap,
  faHeart,
  faHome,
  faHourglass,
  faHourglassHalf,
  faHouseUser,
  faImage,
  faLaptop,
  faLink,
  faList,
  faLock,
  faMale,
  faMapMarkerAlt,
  faMars,
  faMobileAlt,
  faPaperPlane,
  faPaperclip,
  faParking,
  faPassport,
  faPaw,
  faPhone,
  faPlus,
  faQuestion,
  faQuestionCircle,
  faShoppingCart,
  faSignOutAlt,
  faStar,
  faTimes,
  faTimesCircle,
  faTrash,
  faUnlock,
  faUser,
  faUserMd,
  faUsers,
  faVenus,
  faWallet,
  faWater,
} from '@fortawesome/free-solid-svg-icons';

config.autoAddCss = false;

library.add(
  faAt,
  faHourglass,
  faHourglassHalf,
  faHouseUser,
  faMobileAlt,
  faLaptop,
  faPhone,
  faStar,
  faUser,
  faPlus,
  faPaperclip,
  faLink,
  faTimes,
  faAngleDown,
  faAngleLeft,
  faQuestionCircle,
  faAngleRight,
  faTimesCircle,
  faTrash,
  faCheck,
  faGraduationCap,
  faMapMarkerAlt,
  faAddressBook,
  faMale,
  faCreditCard,
  faShoppingCart,
  faCalendarCheck,
  faParking,
  faWater,
  faPaw,
  faHome,
  faLock,
  faGift,
  faUnlock,
  faEye,
  faEyeSlash,
  faImage,
  faPaperPlane,
  faComments,
  faQuestion,
  faCog,
  faHeart,
  faCalendar,
  faPassport,
  faWallet,
  faList,
  faUsers,
  faPaw,
  faComment,
  faUserMd,
  faBabyCarriage,
  faHourglassHalf,
  faBan,
  faGlobe,
  faEllipsisH,
  faVenus,
  faMars,
  faDog,
  faSignOutAlt,
  faEllipsisV,
);
